export const PageSizes = [3, 5, 10, 15, 50, 100];

export interface IPaginatorState {
  page: number;
  pageSize: number;
  total?: number;
  recalculatePaginator(total: number): IPaginatorState;
}

export class PaginatorState implements IPaginatorState {
  page = 1;
  pageSize = PageSizes[3];
  total = 0;
  pageSizes: number[] = [];

  constructor(pageSize?: number, pageNumber?: number) {
    console.log('------- Recived page size ---------', pageSize);
    console.log('------- Recived page number ----------- ', pageNumber);
    if (pageNumber) {
      this.page = pageNumber;
    }

    if (pageSize) {
      this.pageSize = pageSize;
    }
  }

  recalculatePaginator(total: number): PaginatorState {
    this.total = total;
    return this;
  }
}

export interface IPaginatorView {
  paginator: PaginatorState;
  ngOnInit(): void;
  paginate(paginator: PaginatorState): void;
}
